module.exports = __webpack_public_path__ + "static/onmymind_bn_imgM@2x-e49ab3c8fde41c6b1a3a8a56cb051139.png";